import { formatDateForAPI } from "utils/utils";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { createTask } from "./api";
import { queryClient } from "utils/react-query";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { assignee, ...rest } = values;

  const payload = {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
    due_date: formatDateForAPI(values.due_date) || null,
    status: values.status || "open",
  };

  if (assignee !== undefined) {
    payload.assignee = assignee?.id;
  }

  return payload;
}

export function useCreateTask() {
  return useMutation({
    mutationFn: async ({ values }) => {
      const payload = buildPayload(values);
      const response = await createTask({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Task Created Successfully");
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.error(error);
    },
  });
}
